// Assemble the submission payload (the contract in SPEC.md §7) and build the multipart body.

import { RRWEB_VERSION } from './recorder/rrweb.js';

// Injected by the build (esbuild --define); 'dev' when running unbundled.
export const WIDGET_VERSION = typeof __FF_VERSION__ !== 'undefined' ? __FF_VERSION__ : 'dev';

export function buildPayload(cfg, store, audioBlob) {
  return {
    schemaVersion: 1,
    widgetVersion: WIDGET_VERSION,
    projectId: cfg.projectId || null,
    sessionId: uuid(),
    submittedAt: new Date().toISOString(),
    org: cfg.org || null,
    user: cfg.user || null,
    metadata: cfg.metadata || null,
    context: store.context,
    recording: {
      rrwebVersion: RRWEB_VERSION,
      packed: false,
      rrwebEvents: store.rrwebEvents,
      audio: audioBlob
        ? { mimeType: audioBlob.type || null, bytes: audioBlob.size, durationMs: store.context.durationMs, ref: 'audio' }
        : null,
    },
    timeline: {
      ...groupTimeline(store.timeline),
      dropped: store.dropped, // per-channel counts of events lost to buffer caps (usually all 0)
    },
  };
}

// Denormalise the flat timeline into the LLM-friendly grouped shape.
function groupTimeline(flat) {
  const out = { clicks: [], network: [], console: [], routes: [] };
  for (const e of flat) {
    if (e.type === 'click') out.clicks.push(strip(e));
    else if (e.type === 'network') out.network.push(strip(e));
    else if (e.type === 'console') out.console.push(strip(e));
    else if (e.type === 'route') out.routes.push(strip(e));
  }
  return out;
}

function strip(e) {
  const { type, ...rest } = e;
  return rest;
}

// Build multipart/form-data: JSON payload part (optionally gzipped) + audio blob part.
export async function buildMultipart(payload, audioBlob) {
  const fd = new FormData();
  let json = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  json = await maybeGzip(json); // gzips to application/json+gzip when supported
  fd.append('payload', json, 'payload.json');
  if (audioBlob) fd.append('audio', audioBlob, audioFilename(audioBlob));
  return fd;
}

function audioFilename(blob) {
  const t = blob.type || '';
  if (t.includes('mp4')) return 'audio.mp4';
  if (t.includes('ogg')) return 'audio.ogg';
  return 'audio.webm';
}

async function maybeGzip(blob) {
  if (typeof CompressionStream === 'undefined') return blob;
  try {
    const stream = blob.stream().pipeThrough(new CompressionStream('gzip'));
    const gz = await new Response(stream).blob();
    return new Blob([gz], { type: 'application/json+gzip' });
  } catch (_) {
    return blob;
  }
}

function uuid() {
  if (crypto && crypto.randomUUID) return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
